export const previewContentDefaultProps = {
  alignment: 'topLeft',
  children: null,
  trigger: null,
};

export const contentDefaultProps = { title: '', description: '', details: [] };

export const actionsDefaultProps = {};

export const statusDefaultProps = { icon: '', text: '' };

export const coverDefaultProps = {};

export const contentContainerDefaultProps = {};

export const contentTopContainerDefaultProps = {};
